module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": _vm.navto
    }
  }, [_c('img', {
    staticClass: "naviconimage",
    attrs: {
      "src": _vm.iconPath(_vm.icon)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bignavlabel"
  }, [_vm._v(_vm._s(_vm.word))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb5453e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/bigicon.vue
// module id = 199
// module chunks = 0